export default {
  en: {
    headerBanner: 'Free e-Book:\nThe Modern Data Stack:\nA Technical Roadmap',
    headerBannerLink: 'Download for free now!',
    GetQuoteBtn: 'Get a quote',
    LearnMore: 'Learn more',
    AllRights: `© ${new Date().getFullYear()} Mutt Data. All Rights Reserved.`,
  },
};
